import { makeStyles } from "@material-ui/core/styles";

export const useUsersStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  userTableRoot: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  UserTable: {
    minWidth: 1090
  },
  addNewIconRight: {
    marginRight: theme.spacing(1)
  },
  deleteIconMargin: {
    marginRight: theme.spacing(1),
    backgroundColor: "white",
    boxShadow: "none",
    borderRadius: "0.3em",
  },
  editIconMargin: {
    marginRight: theme.spacing(1),
     backgroundColor: "white",//"#8bc34a",
    boxShadow: "none",
    borderRadius: "0.3em",
    "&:hover": {
      backgroundColor:"#717d8a",
    }
  },
  editIcon: {
    width: ".90em",
    height: ".90em",
    color:"#3d5a79 !important",
    
  },
  deleteIcon: {
    width: "1em",
    height: "1em",
    color:"royalblue",
  },
  UserListTitle: {
    fontWeight: 800,
    fontSize: "1.7em"
  },
  SearchInput: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  searchPaper: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400
  },
  buttonStyle:{
    paddingTop: "3em",
    textAlign:"right"
  },
  fieldSpace:{
    paddingTop:"3em",
    paddingLeft:"3em", 
    paddingRight:"3em",
     paddingBottom:"3em"
  },
  userTitle:{
    paddingLeft:"1em",
    paddingBottom:"1em",
    fontWeight:"bold",
    fontSize:"2em"
  },
  buttonPosition:{
    paddingTop:"2.5em"
  },
  passwordCardStyle:{
    minHeight:"32em" ,
    width :"65em",
    margin:"auto"
  },
  passwordHeading:{
    fontSize:"1.5em" ,
    fontWeight:"bold",
    paddingLeft:".50em"
  },
  passwordStyle:{
    paddingLeft:"3em",
    paddingTop:"3em",
    paddingRight:"5em"
  },
  passwordTextStyle:{
    textAlign:"center",
    fontSize:"1.25em"
  },
  resetPasswordStyle:{
    color:"black",
    fontSize:"1em"
  },
  resetPasswordPosition:{
    paddingTop:".80em"
  },
  fieldLabelStyles:{
    paddingBottom:"1em",
    fontWeight:"bold"
  },
  asterisk:{
    color:"red"
  }
}));
